import { Routes } from '@angular/router';
import { NoAuthGuard } from './core/guard/no-auth.guard';
import { AuthGuard } from './core/guard/auth.guard';
import { SectionGuard } from './core/guard/section.guard';
import { CompanyGuard } from './core/guard/company.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'Home',
    pathMatch: 'full'
  },

  {
    path: '',
    loadComponent: () => import('./features/auth/auth.component').then((m) => m.AuthComponent),
    children: [
      { path: 'login', loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent), canActivate: [NoAuthGuard] },
      { path: 'forgot-password', loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent), canActivate: [NoAuthGuard] }
    ]
  },
  {
    path: '',
    loadComponent: () => import('./features/features.component').then(m => m.FeaturesComponent),
    children: [
      {
        path: '', // 👈 فاضي عشان /companies
        loadComponent: () => import('./features/btakka-home/btakka-home.component').then(m => m.BtakkaHomeComponent),
        children: [
          {
            path: 'Account', // 👈 كده URL هيبقى /accounts
            loadComponent: () => import('./features/ERP/accounts/accounts-home/accounts-home.component').then(m => m.AccountsHomeComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'Cost-Center', // 👈 كده URL هيبقى /co
            loadComponent: () => import('./features/ERP/CostCenter/cost-center-home/cost-center-home.component').then(m => m.CostCenterHomeComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'Journal-Type', 
            loadComponent: () => import('./features/ERP/JournalType/journal-type-home/journal-type-home.component').then(m => m.JournalTypeHomeComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
              path: 'Home', // 👈 كده URL هيبقى /companies
              loadComponent: () => import('./features/btakka-home/companies/companies-home/companies-home.component').then(m => m.CompaniesHomeComponent),
              canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'Protofolio', // 👈 كده URL هيبقى /project
            loadComponent: () => import('./features/btakka-home/Project/projects/projects.component').then(m => m.ProjectsComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'ProtofolioDetails/:id', // 👈 كده URL هيبقى /projectdetails/1
            loadComponent: () => import('./features/btakka-home/Project/projectdetails/projectdetails.component').then(m => m.ProjectdetailsComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'FinishingInspectionRequest', // 👈 كده URL هيبقى /co
            loadComponent: () => import('./features/btakka-home/FinishingInspectionRequest/get-finishing-inspection-request/get-finishing-inspection-request.component').then(m => m.GetFinishingInspectionRequestComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'ContractRequest',
            loadComponent: () => import('./features/btakka-home/ContractRequest/get-contract-request/get-contract-request.component').then(m => m.GetContractRequestComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'Operation',
            redirectTo: 'Operation/unit',
            pathMatch: 'full'
          },
          {
            path: 'Operation/:tab',
            loadComponent: () => import('./features/operation/operation.component').then(m => m.OperationComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'UnitDashboard/:id',
            loadComponent: () => import('./features/operation/unit/unit-dashboard/unit-dashboard.component').then(m => m.UnitDashboardComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'EngineersBalance',
            loadComponent: () => import('./features/operation/engineer/total-engineers-balance/total-engineers-balance.component').then(m => m.TotalEngineersBalanceComponent),
            canActivate: [AuthGuard, SectionGuard, CompanyGuard]
          },
          {
            path: 'UnitsBalance',
            loadComponent: () => import('./features/operation/unit/get-units-balance/get-units-balance.component').then(m => m.GetUnitsBalanceComponent),
            canActivate: [AuthGuard, SectionGuard, CompanyGuard]
          },
          {
            path:'Settling',
            loadComponent: () => import('./features/operation/settling/settling.component').then(m => m.SettlingComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path:'SettlementDetails/:id',
            loadComponent: () => import('./features/operation/settling/settlement-details/settlement-details.component').then(m => m.SettlementDetailsComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'Planes', // 👈 كده URL هيبقى /planes
            loadComponent: () => import('./features/btakka-home/planes/planes/planes.component').then(m => m.PlanesComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path:'Management', // 👈 كده URL هيبقى /management
            loadComponent: () => import('./features/operation/management/management.component').then(m => m.ManagementComponent),
            canActivate: [AuthGuard, SectionGuard, CompanyGuard]
          },
          {
            path: 'ImpressSettlement/:id/:tab',
            loadComponent: () => import('./features/operation/unit/impress-settlement/impress-settlement.component').then(m => m.ImpressSettlementComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'EngineerDetails/:id/:tab',
            loadComponent: () => import('./features/operation/engineer/engineerdetails/engineerdetails.component').then(m => m.EngineerdetailsComponent),
            canActivate: [AuthGuard, SectionGuard, CompanyGuard]
          },
          {
            path: 'StatementExpenses/:id',
            loadComponent: () => import('./features/operation/unit/statement-expenses/statement-expenses.component').then(m => m.StatementExpensesComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'StatementExpensesDetails/:id/:index',
            loadComponent: () => import('./features/operation/unit/statement-expenses/statement-expenses-details/statement-expenses-details.component').then(m => m.StatementExpensesDetailsComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'AccountStatement/:id',
            loadComponent: () => import('./features/operation/unit/account-statement/account-statement.component').then(m => m.AccountStatementComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'UnitDetails/:id',
            loadComponent: () => import('./features/operation/unit/unit-details/unit-details.component').then(m => m.UnitDetailsComponent),
            canActivate: [AuthGuard, SectionGuard]
          },
          {
            path: 'About',
            loadComponent: () => import('./features/side-menu-screens/about-btakka/about-btakka.component').then(m => m.AboutBtakkaComponent),
            canActivate: [AuthGuard]
          },
          {
            path: 'Faqs',
            loadComponent: () => import('./features/side-menu-screens/faqs/faqs.component').then(m => m.FaqsComponent),
            canActivate: [AuthGuard]
          },
          {
            path: 'PrivacyPolicy',
            loadComponent: () => import('./features/side-menu-screens/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
            canActivate: [AuthGuard]
          },
          {
            path: 'TermsConditions',
            loadComponent: () => import('./features/side-menu-screens/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent),
            canActivate: [AuthGuard]
          }
        ]
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'Home',
    pathMatch: 'full'
  }
] as const;
